<template>
    <div class="layout">
        <AppHeader/>
        <div class="layout__container">
            <router-view/>
        </div>
        <AppFooter/>
        <AppBottomNav/>
    </div>
</template>

<script>
    import AppHeader from '@components/AppHeader'
    import AppFooter from '@components/AppFooter'
    import AppBottomNav from '@components/AppBottomNav'

    export default {
        name: "Layout",
        components: {
            AppFooter,
            AppHeader,
            AppBottomNav
        }
    }
</script>

<style lang="scss">

    @import "@assets/styles/varibles.scss";
    @import "@assets/styles/mixins.scss";

    .layout {
        position: relative;
        width: 100%;

        &__container {
            background-color: $backgroundColor;
            background-color: var(--backgroundColor);
            @include transition-colors;
        }
    }
</style>